const FAST_POLL_INTERVAL_MS = 5000
const SLOW_POLL_INTERVAL_MS = 10000
const FAST_POLL_COUNT = 6
const LOADING_MESSAGE_CYCLE_START = 5

const POLL_STATUS = {
  COMPLETED: 'completed',
  ERROR: 'error',
  FAILED: 'failed',
}

const SNACKBAR_VARIANTS = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
}

const TAB_VALUES = {
  APPLICABILITY: 'applicability',
  ARGUMENTS: 'arguments',
  CLAIMS: 'claims',
  DOCUMENT: 'document',
}

const CLAIM_STATUS_FILTER_VALUES = {
  ADMISSIBLE: 'admissible',
  ALL: 'all',
  GROUNDLESS: 'groundless',
}

const CLAIM_STATUS_FILTERS = [
  { value: CLAIM_STATUS_FILTER_VALUES.ALL, label: 'Todos' },
  { value: CLAIM_STATUS_FILTER_VALUES.ADMISSIBLE, label: 'Com fundamento' },
  { value: CLAIM_STATUS_FILTER_VALUES.GROUNDLESS, label: 'Sem fundamento' },
]

const DOCUMENT_VERSIONS = {
  APPELLATIVE: 'appellative',
  STANDARD: 'standard',
}

const DOCUMENT_VERSION_LABEL = {
  [DOCUMENT_VERSIONS.APPELLATIVE]: 'apelativa',
  [DOCUMENT_VERSIONS.STANDARD]: 'padrão',
}

const FORM_FIELDS = {
  AUDITOR_ALTERNATIVE_ID: 'auditorAlternativeId',
  QUESTION_CODE: 'questionCode',
  REPORT_TEXT: 'reportText',
  UNIT_ALTERNATIVE_ID: 'unitAlternativeId',
}

const CATEGORY_DESCRIPTION_FIELDS = {
  DESCRIPTION: 'description',
  NAME: 'name',
}

const EMPTY_CATEGORY_DESCRIPTION_ITEM = {
  [CATEGORY_DESCRIPTION_FIELDS.DESCRIPTION]: '',
  [CATEGORY_DESCRIPTION_FIELDS.NAME]: '',
}

const ACTIVITY_DISPUTE_MESSAGES = {
  GENERATION_ERROR: 'Erro ao gerar o documento de contestação.',
  STATUS_ERROR: 'Falha ao verificar o status da contestação.',
}

const LOADING_MESSAGES = [
  'Iniciando a análise da contestação pela DAI',
  'Preparando o processamento do documento',
  'A DAI está analisando os dados da atividade. Isso pode levar alguns minutos',
  'Processamento em andamento. Por favor, aguarde',
  'Analisando critérios e referências aplicáveis',
  'Ainda processando. Análises complexas podem levar alguns minutos',
  'A geração do documento está em andamento. Não feche esta página',
  'Processamento em andamento. O tempo pode variar conforme a complexidade da análise',
  'A DAI continua trabalhando no documento. Por favor, aguarde',
]

const FETCHING_MESSAGES = [
  'Carregando informações da contestação',
  'Recuperando os dados da análise',
  'Quase lá. Carregando o documento de contestação',
]

const ALTERNATIVE_LETTERS = ['A', 'B', 'C', 'D', 'E', 'N/A']

const STRENGTH_LABEL = {
  strong: 'Forte',
  medium: 'Média',
  weak: 'Fraca',
  groundless: 'Improcedente',
}

const APPLICABILITY_STATUS = {
  ATTENDED: 'atendido',
  PARTIALLY_ATTENDED: 'parcialmente_atendido',
}

const APPLICABILITY_STATUS_LABEL = {
  [APPLICABILITY_STATUS.ATTENDED]: 'Atendido',
  [APPLICABILITY_STATUS.PARTIALLY_ATTENDED]: 'Parcial',
}

const CLAIM_TYPE_LABEL = {
  ds010: 'DS.010 (formal)',
  requisito_caderno: 'Requisito do caderno',
  escopo: 'Fora de escopo',
  evidencia_insuficiente: 'Evidência insuficiente',
  tempo_uso: 'Tempo de uso',
}

const DS010_ITEM_LABEL = {
  i: 'PDF',
  ii: 'Idioma',
  iii: 'Empresa/relação',
  iv: 'Aprovação/assinatura',
  v: 'Data',
  vi: 'Destaque/grifo',
}

const ARGUMENT_CATEGORY_LABEL = {
  alegacao_sem_prova: 'Alegação sem prova',
  escopo_extrapolado: 'Fora de escopo',
  evidencia_em_outro_arquivo: 'Evidência em outro arquivo',
  form_ds010: 'Forma da evidência (DS.010)',
  rebaixamento_desproporcional: 'Rebaixamento desproporcional',
  requisito_controle: 'Requisito do controle',
  tempo_uso: 'Tempo de uso',
}

const SPECIALIST_LABEL = {
  control_requirement: 'Especialista requisito do controle',
  ds010_highlight: 'Especialista DS.010 destaque',
  ds010_objective: 'Especialista DS.010 objetivo',
  operational_evidence: 'Especialista evidência operacional',
  scope: 'Especialista de escopo',
  time_usage: 'Especialista tempo de uso',
}

const OVERLAY_LABEL = {
  cross_file: 'Achado em outro arquivo',
  proportionality: 'Proporcionalidade',
}

const DISPUTE_MODAL_CONFIG = {
  FILE_ACCEPT: '.pdf',
  FORM_ID: 'dispute-modal-form',
}

const DISPUTE_MODAL_FEEDBACK = {
  getFailedUploadsMessage: (failedCount) =>
    `${failedCount} arquivo(s) não puderam ser enviados e serão ignorados na contestação.`,
  PROCESSING_MESSAGE:
    'Contestação em processamento. Não saia desta tela e acompanhe o resultado na seção "Contestação gerada pela DAI".',
}

const QUESTION_CODES = Array.from({ length: 42 }, (_, i) => {
  const number = String(i + 1).padStart(2, '0')
  return `UB${number}`
})

const DEFAULT_QUESTION_CODE = ''
const DEFAULT_AUDITOR_ALTERNATIVE_ID = null
const DEFAULT_UNIT_ALTERNATIVE_ID = null
const DEFAULT_REPORT_TEXT = ''
const DEFAULT_NON_CONFORMITIES = []
const DEFAULT_IMPROVEMENT_OPPORTUNITIES = []

export default {
  ALTERNATIVE_LETTERS,
  STRENGTH_LABEL,
  APPLICABILITY_STATUS,
  APPLICABILITY_STATUS_LABEL,
  CLAIM_TYPE_LABEL,
  DS010_ITEM_LABEL,
  ARGUMENT_CATEGORY_LABEL,
  SPECIALIST_LABEL,
  OVERLAY_LABEL,
  QUESTION_CODES,
  DEFAULT_QUESTION_CODE,
  DEFAULT_AUDITOR_ALTERNATIVE_ID,
  DEFAULT_UNIT_ALTERNATIVE_ID,
  DEFAULT_REPORT_TEXT,
  DEFAULT_NON_CONFORMITIES,
  DEFAULT_IMPROVEMENT_OPPORTUNITIES,
  FAST_POLL_INTERVAL_MS,
  SLOW_POLL_INTERVAL_MS,
  FAST_POLL_COUNT,
  LOADING_MESSAGE_CYCLE_START,
  POLL_STATUS,
  SNACKBAR_VARIANTS,
  TAB_VALUES,
  CLAIM_STATUS_FILTER_VALUES,
  CLAIM_STATUS_FILTERS,
  DOCUMENT_VERSIONS,
  DOCUMENT_VERSION_LABEL,
  FORM_FIELDS,
  CATEGORY_DESCRIPTION_FIELDS,
  EMPTY_CATEGORY_DESCRIPTION_ITEM,
  ACTIVITY_DISPUTE_MESSAGES,
  LOADING_MESSAGES,
  FETCHING_MESSAGES,
  DISPUTE_MODAL_CONFIG,
  DISPUTE_MODAL_FEEDBACK,
}
